// extracted by mini-css-extract-plugin
module.exports = {"reviewsDetails":"reviewsDetails_reviewsDetails__q20Pw"};